export enum CurrencyForecastType {
  LEVEL = 'level',
  RETURN = 'return',
}
export enum CurrencyRelativeType {
  USD = 'usd',
  BASE_CUR = 'baseCur',
}

export enum CalculationMethods {
  NO_ARBITRAGE = 'noArbitrage',
  AGING = 'aging',
  FULL_VALIDATION = 'fullValuation',
}

export enum HedgingParamType {
  UNHEDGED = 'unhedged',
  HEDGED = 'hedged',
  HEDGED_BY_COMPONENT = 'hedgedByComponent',
}

export enum YieldCurveShockTypes {
  KEY_RATES = 'keyRates',
  D_VALUES = 'dValues',
}

export const enum YieldCurveValuesType {
  PAR = 'par',
  SPOT = 'spot',
}

export const enum RunAndScheduleType {
  RUN = 'Run',
  SCHEDULE = 'Schedule',
}

export const enum ActionMode {
  VIEW,
  CREATE,
  UPDATE,
  DELETE,
}
export enum SCENARIO_CURVE_TYPES {
  YIELD_CURVE = 'Yield Curve',
  FX = 'FX',
  SPREADS = 'Spreads',
  EQUITY = 'Equity',
  PREPAYMENT = 'Prepayment',
  VOLATILITY = 'Volatility',
}

export enum UserPermission {
  VIEW_REPORT_TEMPLATE = 'ViewReportTemplate',
  EDIT_REPORT_TEMPLATE = 'EditReportTemplate',
  DELETE_REPORT_TEMPLATE = 'DeleteReportTemplate',
  RUN_SCENARIO = 'RunScenario',
  SCHEDULE_SCENARIO = 'ScheduleScenario',
  VIEW_PORTFOLIOS = 'ViewPortfolios',
  VIEW_BENCHMARK = 'ViewBenchmark',
}
